// True only for the HMAC-signed CDP preview surface
// (/preview/desktop|mobile[/full]/{id}?…&sig=…). Path AND sig together: when the
// player runs via the mapping script on a publisher page, window.location is the
// publisher's URL, so a publisher path that merely sits under /preview must not
// be mistaken for an admin preview — the signed CDP link always carries `sig`, a
// coincidental publisher path never does.
//
// The mobile preview shell renders the player in a same-origin iframe whose own
// URL lacks the marker, so also consult the top window when it is reachable
// (same-origin). Cross-origin access throws (publisher / MCP embeds mount the
// player in a cross-origin iframe) — treat that as "not an admin preview" so
// those surfaces keep tracking.
function matchesSignedPreview(location: Location): boolean {
  const isPreviewPath = /^\/preview\/(desktop|mobile)(?:\/full)?\//.test(
    location.pathname,
  );
  const hasSig = new URLSearchParams(location.search).has("sig");
  return isPreviewPath && hasSig;
}

export function isAdminPreviewSurface(): boolean {
  if (matchesSignedPreview(window.location)) {
    return true;
  }
  try {
    if (window.top && window.top !== window.self) {
      // Same-origin nested iframe (mobile preview shell) — throws if cross-origin.
      return matchesSignedPreview(window.top.location);
    }
  } catch (_) {
    // Cross-origin top → not our preview surface.
  }
  return false;
}
